import React, { useState } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import { DatePicker, Menu, Dropdown, Badge } from 'antd'

import { AiOutlineDown, AiOutlineReload } from 'react-icons/ai'
import { BiSelectMultiple } from 'react-icons/bi'

import { normalize, stringifyDate, useListData, useToggle, usePet, server, useShift } from '../../modules'

import Receive from '../../components/reusable/receive'
import Confirm from '../../components/reusable/confirm'
import Patient from '../../components/reusable/patient'

import Cancel from '../../components/modals/cancel'
import Refund from '../../components/modals/refund'
import PrintIFrame from '../../components/modals/printIFrame'
import Elevated from '../../components/modals/elevated'
import PayModal from '../../components/modals/paymodal'
import OrderModal from '../../components/modals/ordermodal'
import SelectStation from '../../components/modals/selectstation'
import ApplyDiscount from '../../components/modals/applyDiscount'

import BillPatient from '../../components/drawers/billPatient'

const { RangePicker } = DatePicker

const Bills = ({ categories: ctgs, status }) => {
    const [token, setToken] = useState()
    const [count, setCount] = useState(0)
    const [type, setType] = useState(status)
    const [string, setString] = useState('')
    const [ranges, setRanges] = useState([])
    const [chosen, setChosen] = useState([])
    const [selected, setSelected] = useState()
    const [category, setCategory] = useState('')
    const [categories, setCategories] = useState(ctgs)
    const [onSuccess, setOnSuccess] = useState(() => null)

    const [select, toggleSelect] = useToggle()
    const [iframe, toggleIFrame] = useToggle()
    const [refund, toggleRefund] = useToggle()
    const [cancelB, toggleCancel] = useToggle()
    const [payModal, togglePayModal] = useToggle()
    const [elevated, toggleElevated] = useToggle()
    const [billPt, toggleBillPatient] = useToggle()
    const [inPatient, toggleInPatient] = useToggle()
    const [orderModal, toggleOrderModal] = useToggle()
    const [discountModal, toggleDiscount] = useToggle()
    const [stationsModal, toggleStationsModal] = useToggle()

    const { user, shift } = useSelector(state => state.application)

    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const [
        { loading, error, fetch },
        { list: orders },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('hospitalBills', ranges ? { string, inPatient, type: type?.value, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null } : { inPatient, type: type?.value, string }, { notify: true }, 'bills')

    const [, revoke] = usePet('revokeDiscount', {  bill: selected?._id }, { notify: true, callback: fetch, manual: true, load: { msg: 'Revoking discount...' }, token }) 
    
    const [, inPatientBills] = usePet('hospitalBills', { inPatient: true, type: 'Open' }, { callback: ({ data }) => setCount(data?.count ?? 0) }) 

    const [{ loading: mLoading }, merge] = usePet('mergeBills', {
        ids: chosen
    }, {
        notify: true, callback: ({ }, notif, ops) => {
            notif('Bills have been merged', ops('success'))
            fetch()
            togSelect()
        }, manual: true, load: { msg: 'Merging bills...' }
    })

    const [, toggleCancelBill] = usePet('toggleCancelBill', {
        id: selected?._id
    }, { notify: true, callback: fetch, manual: true, load: { msg: 'Undoing cancel...' } })

    const [, toggleWaiveBill] = usePet('toggleWaiveBill', {
        id: selected?._id
    }, { notify: true, callback: fetch, manual: true, load: { msg: selected?.waived ? 'Removing waiver...' : 'Waiving bill...' }, token })

    const [{ loading: sLoading, error: sError }] = usePet('routingGroupNames', {}, { notify: true, callback: ({ data }) => setCategories(data), logOutOnError: true })

    const [{ loading: dLoading }, deleteBills] = usePet('deleteBills', {
        ids: chosen
    }, {
        notify: true, callback: ({ }, notif, ops) => {
            notif('Bills have been deleted', ops('success'))
            fetch()
            togSelect()
        }, manual: true, load: { msg: 'Deleting bills...' }
    })

    const [, undoRefund] = usePet('undoRefundBill', {
        id: selected?._id
    }, { notify: true, callback: fetch, manual: true, load: { msg: 'Reversing refund action...' }, token })

    const elevate = fn => {
        setOnSuccess({ fn, setToken })
        setTimeout(toggleElevated, 200)
    }

    const [Shifts, ShiftsModal] = useShift("OPD")

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const reload = () => {
        navigate(1)
        inPatientBills()
        fetch()
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0) {
            reload()
        }
    }

    const selectRange = range => {
        setRanges(range)
        reload()
    }

    const viewOrder = ord => {
        setSelected(ord)
        toggleOrderModal()
    }

    const cancelBill = ord => {
        setSelected(ord)
        toggleCancel()
    }

    const recordPayment = ord => {
        setSelected(ord)
        togglePayModal()
    }

    const billPatient = bill => {
        setCategory(categories[0] ?? 'Doctor')
        setSelected(bill)
        setTimeout(toggleBillPatient, 100)
    }

    const changeType = val => {
        setType(val)
        reload()
    }

    const toggleIP = () => {
        toggleInPatient()
        setChosen([])
        reload()
    }

    const toggleWaive = (ord) => elevate(() => {
        setSelected(ord)
        Confirm({
            title: "Waive Bill",
            message: "This will place a waiver on this bill",
            okText: "Waive Bill",
            onOk: toggleWaiveBill
        })
    })

    const showPrintIFrame = ord => {
        setSelected(ord)
        toggleIFrame()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <Receive
                loading={sLoading}
                error={sError}>
                {
                    category ?
                        <BillPatient
                            bill={selected}
                            category={category}
                            patient={selected?.patient}
                            categories={categories}
                            onClose={() => {
                                setCategory()
                                fetch()
                            }}
                            toggle={toggleBillPatient}
                            visible={billPt} />
                        : null
                }
            </Receive>
            {
                payModal &&
                <PayModal
                    onPerform={reload}
                    order={selected}
                    toggle={togglePayModal}
                    visible={payModal} />
            }
            {
                refund &&
                <Refund
                    token={token}
                    onPerform={fetch}
                    order={selected}
                    toggle={toggleRefund}
                    visible={refund} />
            }
            {
                orderModal &&
                <OrderModal
                    order={selected}
                    onPerform={fetch}
                    toggle={toggleOrderModal}
                    visible={orderModal} />
            }
            {
                cancelB &&
                <Cancel
                    order={selected}
                    onPerform={fetch}
                    toggle={toggleCancel}
                    visible={cancelB} />
            }
            {
                discountModal &&
                <ApplyDiscount
                    token={token}
                    order={selected}
                    onPerform={fetch}
                    toggle={toggleDiscount}
                    visible={discountModal} />
            }
            <SelectStation
                toggle={toggleStationsModal}
                visible={stationsModal} />
            {
                elevated &&
                <Elevated
                    onSuccess={onSuccess}
                    toggle={toggleElevated}
                    visible={elevated} />
            }
            {
                iframe &&
                <PrintIFrame
                    content="receipt"
                    visible={iframe} 
                    id={selected?._id}
                    toggle={toggleIFrame}
                    title={ `Bill #${ selected?.orderNo}` } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-search"
                    type="text"
                    placeholder="Patient Name, OP/IP No." />
                { ShiftsModal }
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <RangePicker 
                        onChange={selectRange}
                        ranges={{
                            'Today': [moment().startOf('day'), moment().endOf('day')],
                            'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
                            'This Week': [moment().startOf('week'), moment().endOf('week')],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                        }}/>
                    <Shifts />
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <span>
                        <h2 className="font-semibold text-gray-800">Bills</h2>
                        <span className="cursor-pointer" onClick={ toggleIP }>
                            <input
                                checked={ inPatient }
                                type="checkbox"
                                className="form-checkbox cursor-pointer h-5 w-5" />
                            <Badge count={ count }>
                                <p className="inline ml-2">Inpatient Bills</p>
                            </Badge>
                        </span>
                    </span>
                    <span className="flex items-center justify-between">
                        <Select
                            value={type}
                            onChange={changeType}
                            styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                            options={['All', 'Closed', 'Open', 'Cancelled', 'Waived', 'Refunded'].map(type => ({ label: type, value: type }))}
                            placeholder="Filter By Status" />
                            
                        <button onClick={reload} className="btn ml-2 py-3 hisani-btn-green-light text-white">
                            <AiOutlineReload style={{ color: "white" }} />
                        </button>
                        {
                            chosen.length > 0 ?
                                <Dropdown
                                    overlay={
                                        <Menu>
                                            <Menu.Item onClick={togSelect}>Deselect All</Menu.Item>
                                            {
                                                chosen.length > 1 ?
                                                    <Menu.Item onClick={() => elevate(() => {
                                                        Confirm({
                                                            title: 'Merge Bills?',
                                                            message: 'Please confirm before merging the selected bills',
                                                            okText: 'Merge Bills',
                                                            onOk: merge
                                                        })
                                                    })}>Merge {chosen.length} Bills</Menu.Item>
                                                    : null
                                            }
                                            {
                                                user.issuperuser &&
                                                <Menu.Item onClick={() => elevate(() => {
                                                    Confirm({
                                                        title: 'Delete Bills?',
                                                        message: 'Please note that this action is not reversable',
                                                        okText: 'Delete Bills',
                                                        onOk: deleteBills
                                                    })
                                                })}>Delete</Menu.Item>
                                            }
                                        </Menu>
                                    }>
                                    <button className="btn hisani-btn-green-light ml-2 text-white">
                                        <span className="hidden xs:block mr-2">Bulk Actions ({chosen.length})</span>
                                        <AiOutlineDown />
                                    </button>
                                </Dropdown>
                                :
                                <button onClick={togSelect} className="btn ml-2 hisani-btn-green-light text-white">
                                    <BiSelectMultiple style={{ color: "white" }} />
                                    <span className="hidden xs:block ml-2">{!select ? "Select" : "Deselect All"}</span>
                                </button>
                        }
                    </span>
                </header>
                <div className="p-3">
                    <Receive
                        progress
                        loading={loading}
                        error={error}>
                        {
                            orders?.length > 0 ?
                                <div className="overflow-x-auto">
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                            <th className="p-2">
                                                    <div className="font-semibold text-center">{select ? 'Selected' : 'No'}</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Patient</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Ref No.</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Amount</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                orders.map((order, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">
                                                                {
                                                                    select && !order.closed ?
                                                                        <input
                                                                            onChange={() => choose(order._id)}
                                                                            checked={chosen.includes(order._id)}
                                                                            type="checkbox"
                                                                            className="form-checkbox cursor-pointer h-5 w-5" />
                                                                        :
                                                                        `${((page - 1) * limit) + (key + 1)}.`
                                                                }
                                                            </div>
                                                        </td>
                                                        <td className="p-2">
                                                            <Patient patient={order?.patient} />
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">#{ order.orderNo < 1000 ? ('00000' + order.orderNo).slice(-4) : order.orderNo }</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">Ksh. { normalize(order?.items?.filter(item => !item.cancelled)?.reduce((total, itm) => total + ((itm?.unitPrice - (itm?.discount ?? 0)) * itm?.quantity), 0) - (order?.discount ?? 0)) }</div>
                                                            { order.items.some(item => item.cancelled) ? <p className="text-center line-through mb-0 text-red-400 text-xs italic">Ksh. { normalize(order?.items?.filter(item => item.cancelled)?.reduce((total, itm) => total + ((itm?.unitPrice - (itm?.discount ?? 0)) * itm?.quantity), 0) - (order?.discount ?? 0)) }</p> : null }
                                                        </td>
                                                        <td className="p-2">
                                                            <div className={`text-center ${(order.waived || order.cancelled) ? 'text-red-400' : order.closed ? 'text-green-500' : 'text-yellow-500'}`}>{order.waived ? 'Waived' : order.cancelled ? 'Cancelled' : order.closed ? 'Closed' : 'Open'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(order.date)}</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={() => viewOrder(order)}>View</Menu.Item>
                                                                        {
                                                                            shift &&
                                                                            <>
                                                                                {
                                                                                    !(order.closed || order.waived || order.cancelled) &&
                                                                                    <>
                                                                                        <Menu.Item onClick={ () => billPatient(order) }>Add Items</Menu.Item>
                                                                                        <Menu.Item onClick={ () => recordPayment(order) }>Record Payments</Menu.Item>
                                                                                        { 
                                                                                            !order.cancelled &&
                                                                                            <Menu.Item onClick={ () => elevate(() => {
                                                                                                setSelected(order)
                                                                                                cancelBill(order)
                                                                                            }) }>Cancel Bill</Menu.Item>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                                {
                                                                                    order?.payments?.length > 0 && !order.refunded ?
                                                                                        <Menu.Item onClick={() => elevate(() => {
                                                                                            setSelected(order)
                                                                                            toggleRefund()
                                                                                        })}>Refund Bill</Menu.Item>
                                                                                    : order.refunded ?
                                                                                        <Menu.Item onClick={() => elevate(() => {
                                                                                            setSelected(order)
                                                                                            Confirm({
                                                                                                title: "Undo Refund Bill",
                                                                                                message: "This will undo the refund on the specified bill",
                                                                                                okText: "Remove Refund",
                                                                                                onOk: undoRefund
                                                                                            })
                                                                                        })}>Undo Refund</Menu.Item>
                                                                                    : null
                                                                                }
                                                                                {
                                                                                    order.waived ?
                                                                                        <Menu.Item onClick={ () => toggleWaive(order) }>Remove Waiver</Menu.Item>
                                                                                    : !(order.closed || order.cancelled) ?
                                                                                        <Menu.Item onClick={ () => toggleWaive(order) }>Waive Bill</Menu.Item>
                                                                                    : null
                                                                                }
                                                                                {
                                                                                    (!order.closed && (order.discount || order.waived || order.cancelled)) ?
                                                                                        <>
                                                                                            {
                                                                                                order.cancelled ?
                                                                                                    <Menu.Item onClick={() => elevate(() => Confirm({
                                                                                                        title: "Undo Cancel",
                                                                                                        message: "This will undo the cancel action on this bill",
                                                                                                        okText: "Undo Cancel",
                                                                                                        onOk: toggleCancelBill
                                                                                                    }))}>Undo Cancel</Menu.Item>
                                                                                                : null
                                                                                            }
                                                                                        </>
                                                                                        : null
                                                                                }
                                                                            </>
                                                                        }
                                                                        <Menu.Item onClick={ () => showPrintIFrame(order) }>Print { order.inPatient ? 'Invoice' : 'Bill' }</Menu.Item>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">{string.trim().length > 2 ? `No bills matching "${string}" found` : type?.value === 'All' ? "Please click above to create a new bill" : type?.value === 'Cancelled' ? "No cancelled bills found" : type?.value === 'Open' ? 'No open bills found' : type?.value === 'Shelved' ? 'No shelved bills found' : type?.value === 'Refunded' ? 'No refunded bills found' : 'No waived bills found'}</p>
                                </div>
                        }
                    </Receive>
                    {Paginate}
                </div>
            </div>
        </div>
    )
}

export default Bills